export enum TaskSortingDirection {
  Ascending = "sortingAscending",
  Descending = "sortingDescending",
}
